import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthShell from "./AuthShell";
import AppModal from "./AppModal";
import { getDeviceFingerprint } from "../utils/fingerprint";

function Login({ isArrendatarioRoute = false }) {
  const navigate = useNavigate();
  const isArrendatarioDomain = window.location.hostname.includes("mereferencio") || isArrendatarioRoute;

  const [form, setForm] = useState({
    no_documento: "",
    password: "",
  });

  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info",
  });

  const showModal = (title, message, type = "info") => {
    setModal({ isOpen: true, title, message, type });
  };

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...form,
        device_fingerprint: getDeviceFingerprint()
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL || ""}/api/auth/login/`,
        payload
      );

      // =========================
      // STORE SESSION
      // =========================
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", res.data.user);
      localStorage.setItem("full_name", res.data.name);
      localStorage.setItem("role", res.data.role);
      localStorage.setItem("role_label", res.data.role_label);
      localStorage.setItem("persona_exists", res.data.persona_exists);
      if (res.data.has_consented) {
        localStorage.setItem("has_consented_policies", "true");
      }
      if (res.data.org_display) localStorage.setItem("org_display", res.data.org_display);
      localStorage.removeItem("aviso_habeas_data");

      // =========================
      // ROUTING
      // =========================
      if (res.data.role === "ARRENDADOR" && !res.data.persona_exists) {
        navigate("/personas/crear");
      } else if (res.data.role === "ARRENDATARIO") {
        navigate("/consultar-puntaje");
      } else {
        navigate("/referencias");
      }

    } catch (error) {
      if (error.response && error.response.status === 403) {
        const errorData = error.response.data;
        if (errorData.requires_verification) {
          showModal(
            "Verificación requerida",
            errorData.error || "Debes verificar tu Correo Electrónico y tu Número de Celular por SMS antes de ingresar.",
            "info"
          );
          setTimeout(() => {
            navigate("/register", {
              state: {
                step: 2,
                no_documento: errorData.no_documento || form.no_documento,
                email: errorData.email,
                celular: errorData.celular,
                email_verificado: errorData.email_verificado,
                sms_verificado: errorData.sms_verificado,
              }
            });
          }, 2000);
        } else {
          showModal(
            "Acceso denegado",
            errorData.error || "Debe verificar su Correo Electrónico o su cuenta está bloqueada.",
            "error"
          );
        }
      } else {
        showModal(
          "Acceso denegado",
          "Credenciales incorrectas.",
          "error"
        );
      }
    }
  };

  return (
    <AuthShell
      eyebrow={isArrendatarioDomain ? "Portal de Arrendatarios" : "Acceso principal"}
      title={isArrendatarioDomain ? "Bienvenido a Mereferencio" : ""}
      subtitle=""
      footerLinks={[
        { to: "/register", label: "Crear cuenta" },
        { to: "/forgot", label: "Olvidé mi contraseña" },
      ]}
    >
      <form onSubmit={handleLogin} autoComplete="off">
        <div className="app-field">
          <label>No. de Documento</label>
          <input
            type="text"
            name="no_documento"
            placeholder="No. de Documento"
            value={form.no_documento}
            onChange={handleChange}
            autoComplete="username"
            className="app-input"
          />
        </div>

        <div className="app-field">
          <label>Contraseña</label>
          <input
            type="password"
            name="password"
            placeholder="Contraseña"
            value={form.password}
            onChange={handleChange}
            autoComplete="current-password"
            className="app-input"
          />
        </div>

        <button
          type="submit"
          className="app-button app-button--primary"
        >
          Iniciar sesión
        </button>
      </form>

      <AppModal
        isOpen={modal.isOpen}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        onClose={() =>
          setModal((prev) => ({
            ...prev,
            isOpen: false,
          }))
        }
      />
    </AuthShell>
  );
}

export default Login;